import { render } from "./checkDetail.vue?vue&type=template&id=9c9654ae&scoped=true&ts=true"
import script from "./checkDetail.vue?vue&type=script&lang=ts"
export * from "./checkDetail.vue?vue&type=script&lang=ts"

import "./checkDetail.vue?vue&type=style&index=0&id=9c9654ae&scoped=true&lang=less"

import exportComponent from "/workspace/source-code/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-9c9654ae"]])

export default __exports__